import { useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-grid-system";
import Moment from "react-moment";
import Modal from "react-modal";
import { Button } from "../Button";
import { Status } from "../Status";
import { Keywords } from "../Keywords";
import { Date } from "../Date";
import EditIcon from "../../assets/img/icons/edit.svg";
import { StyledField } from "../../styles/StyledField";
import { StyledDecisionTitle } from "../../styles/StyledDecision";
import { useDecisionContext } from "../../context/decisionContext";
import DeleteDecisionButton from "../Decison/DeleteDecisionButton";
import DecisionStatusControl from "./DecisionStatusControl";
import useDecisionAccess from "../../hooks/useDecisionAccess";

export default function DecisionHeader({ onClick }) {
	const contextData = useDecisionContext();
	const { access, permissions } = useDecisionAccess(contextData?.id);
	
	// Handle case where context is not available or data is not loaded
	if (!contextData) {
		return <div>Loading decision data...</div>;
	}
	
	const { status, name, referenceNumber, decisionDate, validFrom, validTo, category, label, unit, matter, upperDecision, keywords, id } = contextData;

	useEffect(() => {
		Modal.setAppElement("body");
	}, []);

	return (
		<Row>
			<Col sm={5}>
				<StyledDecisionTitle>
					<Status status={status.slug} />
					<div>
						<h1>{name || ""}</h1>
						<DecisionStatusControl id={id} status={status.slug} />
						{permissions.editContent && (
							<Button onClick={onClick} bg={false} icon={EditIcon} small>
								Edit decision
							</Button>
						)}
						{upperDecision && (
							<StyledField>
								<label>Upper decision</label>
								<span>{upperDecision?.name}</span>
							</StyledField>
						)}
					</div>
				</StyledDecisionTitle>
			</Col>
			<Col sm={6} offset={{ sm: 1 }}>
				<Row>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="4px">
							<label>Reference number</label>
							<span>{referenceNumber}</span>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Category</label>
							<span>{category?.name}</span>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Label</label>
							<span>{label?.name}</span>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						{permissions.delete && <DeleteDecisionButton decisionId={id} />}
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledField mb="12px">
							<label>Unit</label>
							<span>{unit?.name}</span>
						</StyledField>
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledField mb="12px">
							<label>owner</label>
							<span>{access?.owner ? `${access.owner.firstName} ${access.owner.lastName}` : "No owner"}</span>
						</StyledField>
					</Col>
				</Row>
				{matter && (
					<Row>
						<Col>
							<StyledField mb="12px">
								<label>Matter</label>
								<span>{matter?.name}</span>
							</StyledField>
						</Col>
					</Row>
				)}
				<Row>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Decision date</label>
							<Date>
								<Moment format="YYYY-MM-DD">{decisionDate}</Moment>
							</Date>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Valid from</label>
							<Date>
								<Moment format="YYYY-MM-DD">{validFrom}</Moment>
							</Date>
						</StyledField>
					</Col>
					<Col sm={4} xl={3} xxxl={2}>
						<StyledField mb="12px">
							<label>Valid to</label>
							<Date>
								<Moment format="YYYY-MM-DD">{validTo}</Moment>
							</Date>
						</StyledField>
					</Col>
					<Col sm={12} xxxl={6}>
						<StyledField>
							<Keywords keywords={keywords} />
						</StyledField>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

DecisionHeader.propTypes = {
	data: PropTypes.object,
	onClick: PropTypes.func,
};
